import { useCallback, useState } from "react"

/**
 * Разбивка длинного списка на страницы. Списки здесь целиком на клиенте
 * (группы — 3 582 строки, справочник — до 13 720), поэтому и страница считается
 * без сервера.
 *
 * Номер страницы не сбрасывается сам: набор меняется и после сохранения строки,
 * а перебрасывать человека в начало списка после каждой правки нельзя. Сброс —
 * дело фильтра, `reset()` рядом с `setSearch`.
 */
export function usePaged<T>(items: T[], size: number) {
	const [wanted, setWanted] = useState(0)

	const pageCount = Math.max(1, Math.ceil(items.length / size))
	const page = Math.min(wanted, pageCount - 1)

	return {
		rows: items.slice(page * size, (page + 1) * size),
		page,
		pageCount,
		goTo: setWanted,
		reset: useCallback(() => setWanted(0), []),
	}
}
